import { ElementType } from "react";
import ApolloContextClients from "@tvg/utils/types/ApolloContext";
import { ComponentName } from "@fdr/types/ts/Home";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { Props } from "../types";

export enum ComponentType {
  FIXED = "fixed",
  TOP = "top",
  BOTTOM = "bottom",
  FULL = "full",
  LARGE = "large",
  SMALL = "small",
  DEFAULT = "default"
}

export interface ComponentProps {
  type: ComponentType;
  props?: Array<keyof Props>;
  context?: Array<keyof ApolloContextClients>;
  component: ElementType;
  isStandalone?: boolean;
  withoutHeaderSpace?: boolean;
  withoutBackground?: boolean;
  headerLink?: HeaderLink;
}

interface HeaderLink {
  label: string;
  to?: string;
  onClick?: NullaryFn<void>;
}

export type ComponentMap = Record<ComponentName, ComponentProps>;

export interface ComponentConfig {
  id: number;
  name: ComponentName;
  description: string;
  subtitle?: string;
}

interface ComponentConf {
  enabled: boolean;
}
export interface ComponentMapOptions {
  [key: string]: ComponentConf;
}
